import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { ToastsStore } from '@bnsf/bnsf-react-toast-messages';
import Select from 'react-select';

import { setView } from '../../redux/actions/setView';
import { setDataReload } from '../../redux/actions/setDataReload';

import { VIEW } from '../../constants/appConstants';
import { getDivisions, getSubdivisions } from '../../services/trackWindow';
import ActionTypes from './constants';

import 'react-select/dist/react-select.css';
import './WindowQuery.css';

const WindowQuery = (props) => {
    const fetchDivisions = () => {
        getDivisions().then(divsResponse => {
            const divs = divsResponse.map(aDiv => ({
                label: aDiv.name,
                value: aDiv.code
            }));
    
            props.setDivList(divs);

            const sQueryParams = localStorage.getItem('queryParams');
            if (sQueryParams) {
                const queryParams = JSON.parse(sQueryParams);
                if (queryParams.division) {
                    props.setSelectedDiv(queryParams.division);
                }
            }
        }, onDivisionFailure)
    }

    const fetchSubdivisions = (aDiv) => {
        getSubdivisions(aDiv).then(subdivsResponse => {
            const subdivs = subdivsResponse.map(aSub => ({
                label: aSub.name,
                value: aSub.name
            }));
    
            props.setSubdivList(subdivs);

            const sQueryParams = localStorage.getItem('queryParams');
            if (sQueryParams) {
                const queryParams = JSON.parse(sQueryParams);
                if (queryParams.subdivisions && queryParams.subdivisions.length > 0) {
                    props.setSelectedSubdivs(queryParams.subdivisions);
                }
            }
        }, onSubdivisionFailure)
    }

    useEffect(() => {
        if (props.divList.length === 0) {
            fetchDivisions();
            fetchSubdivisions();
        }
    }, []);

    useEffect(() => {
        if (props.selectedDiv) {
            fetchSubdivisions(props.selectedDiv);
        }        
    }, [props.selectedDiv]);

    const onDivisionSelected = (selected) => {
        if (props.selectedDivision !== selected) {
            const div = selected ? selected.value : '';
            props.setSelectedDiv(div);            
            props.setSelectedSubdivs([]);
        }
    }

    const onSubdivisionSelected = (selected) => {
        const selectedSubs = selected.map(aSub => aSub.value);
        props.setSelectedSubdivs(selectedSubs);
    }
    
    const onQuery = () => {
        // save/update the query params in local storage
        localStorage.setItem('queryParams', JSON.stringify({
            division: props.selectedDiv,
            subdivisions: props.selectedSubdivs
        }));

        props.setDataReload(true);
        props.setView(VIEW.WINDOW_LIST_VIEW);
    };
    
    const onDivisionFailure = () => ToastsStore.showToast("DIVISION_FAILURE");
    const onSubdivisionFailure = () => ToastsStore.showToast("SUBDIVISION_FAILURE");

    const isOKDisabled = () => {
        return !(props.selectedDiv || (props.selectedSubdivs && props.selectedSubdivs.length > 0));
    }

    return (
        <div className='clsWindowQuery'>
            <h3>Query Windows</h3>
            <div className='clsDropdownWrapper'>       
                <Select 
                    options = { props.divList } 
                    noOptionsMessage = { () => 'No Division Found' }
                    placeholder = 'Select Division' 
                    value = { props.selectedDiv }
                    onChange = { onDivisionSelected } />
                <Select multi
                    name = 'subdivisions'
                    options = { props.subdivList } 
                    noOptionsMessage = { () => 'No Subdivision Found' }
                    placeholder = 'Select Subdivisions' 
                    value = { props.selectedSubdivs }
                    onChange = { onSubdivisionSelected } />
            </div>
            <button className='btn btn-raised btn-bwwp-primary' 
                disabled={ isOKDisabled() } 
                onClick={ onQuery }>Go</button>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {    
        divList: state.windowQuery.divisionList,
        subdivList: state.windowQuery.subdivisionList,
        selectedDiv: state.windowQuery.selectedDivision,
        selectedSubdivs: state.windowQuery.selectedSubdivisions,
        filter: state.windowFilter[VIEW.WINDOW_LIST_VIEW]
    };
}
  
const mapDispatchToProps = dispatch => {
    return {
        setView: (view, params) => dispatch(setView(view, params)),
        setDivList: (divs) => dispatch({ type: ActionTypes.SET_DIVISION_LIST, divisionList: divs }),
        setSubdivList: (subdivs) => dispatch({ type: ActionTypes.SET_SUBDIVISION_LIST, subdivisionList: subdivs }),
        setSelectedDiv: (div) => dispatch({ type: ActionTypes.SET_SELECTED_DIVISION, selectedDivision: div }),
        setSelectedSubdivs: (subdivs) => dispatch({ type: ActionTypes.SET_SELECTED_SUBDIVISIONS, selectedSubdivisions: subdivs }),
        setDataReload: (reload) => dispatch(setDataReload(reload))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(WindowQuery);